<template>
  <div class="cgs-worksheet-updateRow">
    <div class="cgs-updateRow-header">
      <van-nav-bar :border="true">
        <template #left>
          <span class="iconfont cgsIcon-houtui" @click="goBack"></span>
        </template>
        <template #right>
          <span @click="saveRow" v-if="dataChanged && updateable">保存</span>
          <span class="iconfont cgsIcon-gengduocaozuo" v-else @click="moreShow = true"></span>
        </template>
      </van-nav-bar>
    </div>
    <div class="cgs-updateRow-content">
      <v-form-render ref="vFormRef" :form-json="formJson" :form-data="formData" :option-data="optionData"
        @formChange="onFormDataChange" class="vFormContent"></v-form-render>
    </div>

    <van-popup v-model="moreShow" position="bottom" round style="padding:20px 0px" :overlay="!printOverlay">
      <van-cell title="打印/导出" icon="records" @click="printShow = true,printOverlay = true">
        <template #icon>
          <span class="iconfont cgsIcon-lianxi2hebing_dayin"></span>
        </template>
      </van-cell>
    </van-popup>

    <van-popup v-model="printShow" round position="bottom" @close="printOverlay = false">
      <div v-if="printList && printList.length === 0" style="margin:30px 0px;text-align: center;">无可用模板</div>
      <div v-else>
        <van-radio-group v-model="printTemplate">
          <van-cell-group>
            <van-cell v-for="item in printList" :key="item.id" :title="item.name" clickable @click="printTemplate = item,printdisabled = true">
              <template #right-icon>
                <van-radio :name="item" />
              </template>
            </van-cell>
          </van-cell-group>
        </van-radio-group>
        <div style="display:flex;justify-content: center;padding: 5px 0px;">
          <van-button round class="print-derive-PDF" text="导出PDF" @click="printDerive" :disabled="!printdisabled">
            <template #icon>
              <span class="iconfont cgsIcon-pdf"></span>
            </template>  
          </van-button>
          <van-button round class="print-derive-WORD" text="导出word" @click="printDerive" :disabled="!printdisabled">
            <template #icon>
              <span class="iconfont cgsIcon-word"></span>
            </template>  
          </van-button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
  import {
    NavBar,
    Button,
    Icon,
    Popup,
    Cell,
    CellGroup,
    RadioGroup,
    Radio,
  } from "vant";
  import {
    getWorksheetInfo,
    getRow,
    updateRow,
    getAppAuth,
    getPrintList,
    getPrintTemplate,
  } from "@/api/application";
  import "@/assets/style/css/vForm.css";
  import {
    getUserAuthority
  } from "@/util/author";
  export default {
    components: {
      vanNavBar: NavBar,
      vanButton: Button,
      vanIcon: Icon,
      vanPopup: Popup,
      vanCell: Cell,
      vanRadioGroup: RadioGroup,
      vanRadio: Radio,
      vanCellGroup: CellGroup,
    },
    data() {
      return {
        worksheetDetail: {},
        rowDetail: {},
        formJson: {},
        formData: {},
        optionData: {},
        dataChanged: false,
        updateable: false,
        formMounted: false,
        moreShow: false,
        printShow: false,
        printList: [],
        printTemplate:{},
        printOverlay: false,
        printdisabled: false,
      };
    },
    created() {
      window.vformUploadUrlPrefix = process.env.VUE_APP_BASEURL;
    },
    mounted() {
      this.init();
      this.getPrint();
    },
    computed: {
      userId: {
        get() {
          let userAuthority = getUserAuthority();
          return userAuthority.userId;
        },
        set() {},
      },
      worksheetId: {
        get() {
          return this.$route.params.worksheetId;
        },
        set() {},
      },
      rowId: {
        get() {
          return this.$route.params.rowId;
        },
        set() {},
      },
      isMiniProgram() {
        let sUserAgent = navigator.userAgent.toLowerCase();
        if (/miniprogram/.test(sUserAgent)) {
          return true;
        } else {
          return false;
        }
      }
    },
    methods: {
      async printDerive(){
        if(this.isMiniProgram === true){
          this.$message({
            message: "当前小程序不支持打印",
            center: true,
          });;
        }else{
          if(this.printTemplate && this.printTemplate.id){
            let params = {
              id : this.printTemplate.id,
              worksheetId : this.worksheetId,
              rowId : this.rowId
            }
            let result = await getPrintTemplate(params)
            if(result){
              let url = `${process.env.VUE_APP_BASEURL}/file/${result.data.renderPath}`
              let dtask = plus.downloader.createDownload(url, {}, function (d, status) {
                if (status == 200) {
                  let fileUrl = d.filename;
                    plus.runtime.openFile(fileUrl, {}, function (e) {
                      this.$Notify({ type: 'danger', message: '打开失败' })
                    });
                  } else {
                      this.$Notify({ type: 'primary', message: 'Download failed: ' + status })
                  }
              });
              dtask.start();
            }else{
              this.$Notify({ type: 'primary', message: result.msg })
            }
          }
        }
      },
      async getPrint() {
        let result = await getPrintList(this.worksheetId)
        this.printList = result.data
      },
      async init() {
        // this.wholeLoading = true
        try {
          let worksheetResult = await getWorksheetInfo(this.worksheetId);
          let rowRestule = await getRow(this.worksheetId, this.rowId);

          let appId = worksheetResult.data.appId;
          if (appId) {
            let appAuthResult = await getAppAuth(appId);
            let appAuth = appAuthResult.data;
            this.setRowAuth(appAuth, rowRestule.data.owner);
          }

          this.worksheetDetail = worksheetResult.data;
          this.rowDetail = rowRestule.data;
          if ("config" in this.worksheetDetail) {
            let config =
              this.worksheetDetail.config === "" ? [] :
              JSON.parse(this.worksheetDetail.config);
            config.formConfig.labelPosition = "top";
            this.$refs.vFormRef.setFormJson(config);
            this.$refs.vFormRef.setFormData(this.rowDetail);
            this.setFormMounted()
            
          }
        } catch (e) {
          console.error(e);
        } finally {
          // this.wholeLoading = false
        }
      },
      setFormMounted(){
        setTimeout(() => {
          this.formMounted = true
        }, 200)
      },
      goBack() {
        this.$router.go(-1);
      },
      onFormDataChange() {
        if(this.formMounted) this.dataChanged = true;
      },
      async saveRow() {
        if (!this.updateable) {
          this.$Notify({
            type: "danger",
            message: "没有权限,请联系相关人员"
          });
          return;
        }
        this.$Toast.loading({
          message: "提交中...",
          forbidClick: true,
        });
        let formData = await this.$refs.vFormRef.getFormData();
        console.log(formData);
        let result = await updateRow({
          worksheetId: this.worksheetId,
          rowId: this.rowId,
          data: formData,
        });
        if (result) {
          this.$Notify({
            type: "success",
            message: "提交成功"
          });
          // this.goBack()
        } else {
          this.$Notify({
            type: "danger",
            message: "提交失败"
          });
        }
        this.dataChanged = false;
        this.$Toast.clear();
      },

      setRowAuth(appAuthObj, rowOwner) {
        let appAuth = appAuthObj['appAuth']
        if (appAuth.includes("MANAGE_APP_AUTH")) {
            this.updateable = true;
          return;
        }
        if (appAuthObj['formAuth'] === null) {
          if (this.userId === rowOwner) {
            this.updateable = true;
          }
          if (appAuth.includes("EDIT_FORM")) {
            this.updateable = true;
            return;
          }
          if (appAuth.includes("EDIT_FORM2")) {
            this.updateable = false;
            if (this.userId === rowOwner) {
              this.updateable = true;
            }
            return;
          }
          if (appAuth.includes("EDIT_FORM3")) {
            this.updateable = false;
            if (this.userId === rowOwner) {
              this.updateable = true;
            }
            return;
          }

          if (appAuth.includes("EDIT_FORM4")) {
            this.updateable = false;
            return;
          }
        } else {
          let formAuthMap = appAuthObj['formAuth']
          let formAuth = formAuthMap[this.worksheetId]

          if (formAuth.includes("ROW_EDIT_OWN")) {
            if (this.userId === rowOwner) {
              this.updateable = true;
            }
          }

          if (formAuth.includes("ROW_EDIT_ALL")) {
            this.updateable = true;
          }
        }
      },
    },
  };
</script>

<style scoped>
  .cgs-worksheet-updateRow {
    /* background: #f5f5f5; */
    display: flex;
    flex-direction: column;
  }

  /* .cgs-appPage-header{
    color: #fff;
} */
  .cgs-updateRow-content {
    /* flex-grow: 1; */
    flex: 1;
    overflow: hidden;
    padding: 10px;
    overflow-y: auto;
  }
  .print-derive-WORD{
    color:#4894ea;
    background:#fbfbfb;
  }
  .print-derive-PDF{
    margin-right: 20px;
    color: #c74640;
    background:#fbfbfb;
  }
</style>
<style>
  .cgs-worksheet-updateRow .van-radio-group{
    max-height: 200px;
  }
</style>